var _style, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphicReportCollapsedSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 84 84",
    style: {
      enableBackground: "new 0 0 84 84"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#003366;}\r\n\t.st1{fill:#00796B;}\r\n\t.st2{fill:#FFC300;}\r\n\t.st3{fill:#FF6F61;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42,0c-5.5,0-11,1.1-16.1,3.2s-9.7,5.2-13.6,9.1c-3.9,3.9-7,8.5-9.1,13.6S0,36.5,0,42h14.7 c0-3.6,0.7-7.1,2.1-10.4c1.4-3.3,3.4-6.3,5.9-8.9c2.5-2.5,5.5-4.5,8.9-5.9c3.3-1.4,6.9-2.1,10.4-2.1V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,42c0,5.5,1.1,11,3.2,16.1s5.2,9.7,9.1,13.6c3.9,3.9,8.5,7,13.6,9.1C31,82.9,36.5,84,42,84V69.3 c-3.6,0-7.1-0.7-10.4-2.1c-3.3-1.4-6.3-3.4-8.9-5.9c-2.5-2.5-4.5-5.5-5.9-8.9c-1.4-3.3-2.1-6.9-2.1-10.4H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M84,42c0-5.5-1.1-11-3.2-16.1c-2.1-5.1-5.2-9.7-9.1-13.6c-3.9-3.9-8.5-7-13.6-9.1C53,1.1,47.5,0,42,0v14.7 c3.6,0,7.1,0.7,10.4,2.1c3.3,1.4,6.3,3.4,8.9,5.9c2.5,2.5,4.5,5.5,5.9,8.9c1.4,3.3,2.1,6.9,2.1,10.4H84z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M42,84c5.5,0,11-1.1,16.1-3.2c5.1-2.1,9.7-5.2,13.6-9.1c3.9-3.9,7-8.5,9.1-13.6C82.9,53,84,47.5,84,42H69.3 c0,3.6-0.7,7.1-2.1,10.4c-1.4,3.3-3.4,6.3-5.9,8.9c-2.5,2.5-5.5,4.5-8.9,5.9c-3.3,1.4-6.9,2.1-10.4,2.1V84z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicReportCollapsedSm);
export default __webpack_public_path__ + "static/media/graphic-report-collapsed-sm.accbfb29d130395ab9cc81c7371144c4.svg";
export { ForwardRef as ReactComponent };